import axios from 'axios';
import { useLocation } from 'react-router';



const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 600000,
    headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("token"),
        'Access-Control-Allow-Credentials': 'true',
        'Content-Type': 'application/json'
    }
});

axiosClient.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    config.headers.Authorization = 'Bearer ' + token;

    // Set Content-Type to application/json for POST/PUT requests with data
    if ((config.method === 'post' || config.method === 'put') && config.data && typeof config.data === 'object') {
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
});

axiosClient.interceptors.response.use(
    function (response) {
        if ("true" === response.headers['x-change-password']) {
            if (!window.location.href.includes('reset-password') &&
                !window.location.href.includes('login')) {
                window.location.href = '#/profile?changepassword=true';
            }
        }
        return response;
    },
    function (error) {
        if (error.response && error.response.status === 401) {
            if (!window.location.href.includes('reset-password') &&
                !window.location.href.includes('login') &&
                !window.location.href.includes('register')) {
                // Session expired inside the app: redirect and suppress the error
                // so the page being torn down does not flash a handler.
                window.location.href = '#/login';
                return new Promise(() => { });
            }
            // Already on a public page (login/register/reset-password): the 401 is
            // the answer to what the user asked, so let the page report it.
        }
        return Promise.reject(error);
    }
);




export const useQuery = () => new URLSearchParams(useLocation().search);
export const getCurrentUser = () => localStorage.getItem('userName');
export default axiosClient;